// Hero block schema - Full-width hero-style section (formerly Banner)
export const bannerSchema = {
  type: 'banner',
  label: 'Hero',
  description: 'Full-viewport hero section with heading, subheading, and optional button',
  icon: 'Image',
  defaultContent: {
    heading: 'Welcome',
    subheading: 'Add a description for your section',
    buttonText: '',
    buttonLink: '',
    backgroundImage: '',
    alignment: 'center', // 'left' | 'center' | 'right' - legacy text alignment (mapped to textPosition on read)
    textPosition: 'middle-center', // 9-cell grid: '{top|middle|bottom}-{left|center|right}'
    imageAlignment: 'center', // 'left' | 'center' | 'right' - image position for tall images
    overlayOpacity: 0.5,
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading', type: 'text', placeholder: 'Enter heading...' },
    { name: 'subheading', label: 'Subheading', type: 'textarea', placeholder: 'Enter subheading...' },
    { name: 'buttonText', label: 'Button Text', type: 'text', placeholder: 'Learn More (optional)' },
    { name: 'buttonLink', label: 'Button Link', type: 'text', placeholder: 'https://...' },
    { name: 'backgroundImage', label: 'Background Image', type: 'image' },
    {
      name: 'textPosition',
      label: 'Text Position',
      type: 'select',
      options: [
        { value: 'top-left', label: 'Top Left' },
        { value: 'top-center', label: 'Top Center' },
        { value: 'top-right', label: 'Top Right' },
        { value: 'middle-left', label: 'Middle Left' },
        { value: 'middle-center', label: 'Middle Center' },
        { value: 'middle-right', label: 'Middle Right' },
        { value: 'bottom-left', label: 'Bottom Left' },
        { value: 'bottom-center', label: 'Bottom Center' },
        { value: 'bottom-right', label: 'Bottom Right' },
      ],
    },
    {
      name: 'imageAlignment',
      label: 'Image Position',
      type: 'select',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    {
      name: 'overlayOpacity',
      label: 'Overlay Darkness',
      type: 'range',
      min: 0,
      max: 1,
      step: 0.1,
    },
  ],
};
